import { TConnection } from '../../../../../../../api/blueprints/connection.template.types';
import { withViewModel } from '../../../../../../../infrastructure/components/with-view-model';
import { ConnectionOtherFormPresentation } from './connection-other-form.presentation';
import { ConnectionOtherFormVM } from './connection-other-form.viewmodel';

export type ConnectionsTemplateFormProps = {
    connection: TConnection;
    addConnection: (connection: TConnection) => void;
    editConnection: (connection: TConnection) => void;
};

export const ConnectionOtherForm = withViewModel(ConnectionOtherFormPresentation, (props: ConnectionsTemplateFormProps) => {
    return new ConnectionOtherFormVM(props.connection, props.addConnection, props.editConnection);
});
